var _circle, _circle2, _g, _g2, _g3, _g4, _g5, _ellipse, _ellipse2, _path, _g6, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolAssing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1777_4818)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.1667,
    cy: 24,
    r: 24,
    fill: "url(#paint0_linear_1777_4818)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1777_4818",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 49,
    height: 48
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.1667,
    cy: 25,
    r: 24,
    fill: "url(#paint1_linear_1777_4818)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1777_4818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.1667 55.5C38.1667 47.4919 36.4167 41 24.1667 41C11.9167 41 10.1667 47.4919 10.1667 55.5C10.1667 63.5081 16.4348 70 24.1667 70C31.8987 70 38.1667 63.5081 38.1667 55.5Z",
    fill: "url(#paint2_radial_1777_4818)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1777_4818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2796 7.98271C14.4146 7.64002 14.9018 7.64648 15.0277 7.99262L15.2012 8.46976C15.2561 8.6207 15.3959 8.72417 15.5563 8.73252L16.1245 8.7621C16.4908 8.78117 16.6404 9.24197 16.3553 9.47259L15.959 9.79302C15.838 9.89094 15.7847 10.0502 15.8225 10.2012L15.9644 10.7674C16.0527 11.12 15.6629 11.3981 15.3582 11.1999L14.8849 10.8919C14.7523 10.8056 14.5812 10.8056 14.4486 10.8919L13.9753 11.1999C13.6706 11.3981 13.2808 11.12 13.3691 10.7674L13.511 10.2012C13.5488 10.0502 13.4955 9.89094 13.3745 9.79303L12.9764 9.47113C12.6915 9.2407 12.8406 8.78027 13.2066 8.76068L13.7331 8.73249C13.8894 8.72412 14.0265 8.62532 14.0838 8.47967L14.2796 7.98271Z",
    fill: "#FFC700"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1777_4818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.2796 4.98271C28.4146 4.64002 28.9018 4.64648 29.0277 4.99262L29.2012 5.46976C29.2561 5.6207 29.3959 5.72417 29.5563 5.73252L30.1245 5.7621C30.4908 5.78117 30.6404 6.24197 30.3553 6.47259L29.959 6.79302C29.838 6.89094 29.7847 7.05021 29.8225 7.20125L29.9644 7.76741C30.0527 8.12003 29.6629 8.39814 29.3582 8.19989L28.8849 7.89193C28.7523 7.80564 28.5812 7.80564 28.4486 7.89193L27.9753 8.19989C27.6706 8.39814 27.2808 8.12003 27.3691 7.76741L27.511 7.20125C27.5488 7.05021 27.4955 6.89094 27.3745 6.79303L26.9764 6.47113C26.6915 6.2407 26.8406 5.78027 27.2066 5.76068L27.7331 5.73249C27.8894 5.72412 28.0265 5.62532 28.0838 5.47967L28.2796 4.98271Z",
    fill: "#FFC700"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1777_4818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.4732 15.4914C39.5407 15.32 39.7843 15.3232 39.8472 15.4963L39.9965 15.9068C40.0239 15.9822 40.0938 16.034 40.174 16.0381L40.6456 16.0627C40.8288 16.0722 40.9036 16.3026 40.761 16.4179L40.4223 16.6919C40.3617 16.7408 40.3351 16.8205 40.354 16.896L40.4701 17.3592C40.5142 17.5355 40.3193 17.6746 40.167 17.5755L39.7758 17.321C39.7095 17.2778 39.624 17.2778 39.5577 17.321L39.1665 17.5755C39.0142 17.6746 38.8193 17.5355 38.8634 17.3592L38.9795 16.896C38.9984 16.8205 38.9718 16.7408 38.9112 16.6919L38.5716 16.4172C38.4291 16.302 38.5037 16.0718 38.6867 16.062L39.1322 16.0381C39.2104 16.0339 39.2789 15.9845 39.3076 15.9117L39.4732 15.4914Z",
    fill: "#FFC700"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1777_4818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.47318 17.4914C6.54068 17.32 6.78429 17.3232 6.84722 17.4963L6.99648 17.9068C7.02392 17.9822 7.09384 18.034 7.17404 18.0381L7.64565 18.0627C7.82877 18.0722 7.9036 18.3026 7.76101 18.4179L7.42226 18.6919C7.36173 18.7408 7.3351 18.8205 7.35402 18.896L7.47007 19.3592C7.51423 19.5355 7.31934 19.6746 7.16699 19.5755L6.77582 19.321C6.70951 19.2778 6.62399 19.2778 6.55768 19.321L6.16651 19.5755C6.01416 19.6746 5.81926 19.5355 5.86343 19.3592L5.97948 18.896C5.99839 18.8205 5.97177 18.7408 5.91123 18.6919L5.57159 18.4172C5.42911 18.302 5.50369 18.0718 5.68665 18.062L6.1322 18.0381C6.21036 18.0339 6.2789 17.9845 6.30759 17.9117L6.47318 17.4914Z",
    fill: "#FFC700"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.6667,
    cy: 28,
    rx: 2.5,
    ry: 6,
    fill: "url(#paint3_radial_1777_4818)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.66675,
    cy: 28,
    rx: 2.5,
    ry: 6,
    fill: "url(#paint4_radial_1777_4818)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.1667 27.5C38.1667 35.5081 36.4167 42 24.1667 42C11.9167 42 10.1667 35.5081 10.1667 27.5C10.1667 19.4919 16.4348 13 24.1667 13C31.8987 13 38.1667 19.4919 38.1667 27.5Z",
    fill: "url(#paint5_radial_1777_4818)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_1777_4818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.1667 26.881C36.1667 34.442 30.7942 37 24.1667 37C17.5393 37 12.1667 34.442 12.1667 26.881C12.1667 19.3199 17.5393 17 24.1667 17C30.7942 17 36.1667 19.3199 36.1667 26.881Z",
    fill: "url(#paint6_linear_1777_4818)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6667 21.5C17.2667 19.5 20.6667 18.6667 22.1667 18.5C19.6667 19 17.8236 21.1862 17.1667 22.5C16.4595 23.9142 14.1667 23.375 15.6667 21.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1777_4818",
    x: -7.17261,
    y: -11.2706,
    width: 43.677,
    height: 43.5366,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.85098 0 0 0 0 0.670588 0 0 0 0 0.34902 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1777_4818"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1777_4818",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1777_4818",
    x: 6.82739,
    y: -14.2706,
    width: 43.677,
    height: 43.5366,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.85098 0 0 0 0 0.670588 0 0 0 0 0.34902 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1777_4818"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1777_4818",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1777_4818",
    x: 18.4971,
    y: -3.63538,
    width: 42.3384,
    height: 42.2439,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.85098 0 0 0 0 0.670588 0 0 0 0 0.34902 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1777_4818"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1777_4818",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1777_4818",
    x: -14.5029,
    y: -1.63538,
    width: 42.3384,
    height: 42.2439,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.85098 0 0 0 0 0.670588 0 0 0 0 0.34902 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1777_4818"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1777_4818",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_1777_4818",
    x: 12.1667,
    y: 17,
    width: 24,
    height: 22,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1777_4818"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1777_4818",
    x1: 24.1667,
    y1: 0,
    x2: 24.1667,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4285F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1777_4818",
    x1: 24.1667,
    y1: 1,
    x2: 24.1667,
    y2: 49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#235DBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4285F4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1777_4818",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.6667 39.5) rotate(30.9637) scale(8.74643 8.9849)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572917,
    stopColor: "white",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1777_4818",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.6667 28) rotate(80.5377) scale(6.08276 2.63111)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0432427,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572917,
    stopColor: "white",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1777_4818",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.1667 28.6667) rotate(105.709) scale(5.54026 2.48093)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412623,
    stopColor: "white",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1777_4818",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.9792 27.5) rotate(81.4209) scale(14.6641 14.1813)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572917,
    stopColor: "white",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1777_4818",
    x1: 30.1667,
    y1: 35.0952,
    x2: 18.016,
    y2: 18.0223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C3558"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.365282,
    stopColor: "#2C3558"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.690365,
    stopColor: "#414C77",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3558",
    stopOpacity: 0.99
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1777_4818"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.166748)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolAssing);
export default __webpack_public_path__ + "static/media/symbol-assing.db71024def3669474f460cd86ac6568b.svg";
export { ForwardRef as ReactComponent };